import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  ListItem
} from '@mui/material'
import React, { useState } from 'react'

interface Props {
  buttonContent: string
  dialogTitle: string
  handleConfirm: (item?: any) => void
}

const DialogButton = ({ buttonContent, dialogTitle, handleConfirm }: Props) => {
  const [openPopup, setOpenPopup] = useState(false)

  return (
    <Box>
      <ListItem sx={{ padding: '40px 20px' }}>
        <Button
          variant='contained'
          sx={{
            width: '100%',
            textAlign: 'center',
            textTransform: 'none',
            fontSize: '26px',
            padding: '50px 20px',
            backgroundColor: '#364c63'
          }}
          onClick={() => {
            setOpenPopup(true)
          }}
        >
          {buttonContent}
        </Button>
      </ListItem>
      <Dialog
        open={openPopup}
        onClose={() => {
          setOpenPopup(false)
        }}
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenPopup(false)
            }}
          >
            Cancel
          </Button>
          <Button onClick={() => handleConfirm(setOpenPopup)}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default DialogButton
